import * as ScrollMagic from 'scrollmagic'
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap'
import {gsap} from 'gsap'
import googleMapsLoader from './googleMapsLoader'
import mv from './mv'
import prlx from './prlx'
import map from './map'
// import news from './news'
import modal from './modal'


document.addEventListener('DOMContentLoaded', () => {

  const $fix_btn = $('.fix_btn');
  const $main_visual = $('.main_visual');
  const $pagetop = $('.page_top');
  const $first_menu = $('.first_menu');
  const $menu_btn = $('.menu_btn');
  const $menu = $('.menu');
  const $menu_link = $('.menu_nav a');
  const $more_btn = $('.news .more_btn');
  var controller = new ScrollMagic.Controller();

  var scr = 0;
  var prev_scr = 0;
  var ww = window.innerWidth;
  var time = 0;

  modal();


  googleMapsLoader();
  ScrollMagicPluginGsap(ScrollMagic, TweenMax);

  if ($main_visual.length) {
    mv();
    prlx();
    // news();
  };

  $(window).on('load', function() {

    var url = location.href.split("/");
    var url_hash = location.hash;

    if(url_hash){
      $(window).scrollTop(0);
      setTimeout(function(){
        var speed = 1400;
        var position = $(url_hash).offset().top;
        $("html, body").animate({ scrollTop: position }, speed, "easeOutExpo");
      },500);
    }

    $('body').addClass('load');
    if ($('.notfound').length) {
      $pagetop.css('display', 'none');
    };

    if (Useragnt.ios){
      $("meta[name='viewport']").attr('content','width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    }

    time = 1;
    scrollShow(time);
    time = 0.75;

    map();

    if ($main_visual.length) {
      $('body').addClass('op_start');
      if(ww > 750){
  			$main_visual.height(window.innerHeight);
  		}
    };

    if(ww > 750){
      menu(url);
    }

    $('a[href*="#"]').click(function() {
      $menu_btn.removeClass('active');
      $menu.removeClass('open');
      var speed = 1400;
      var href = $(this).attr("href");
      var index   = href.indexOf("#");
      href = "#" + href.slice(index + 1);
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $("html, body").animate({ scrollTop: position }, speed, "easeOutExpo");
      return false;
    });

    $(document).on("click", ".toggle_contents", function(){
      $("+.active_contents",this).slideToggle();
      $(">.toggle_icon",this).toggleClass("active");
    });

    $(document).on("click", ".raw_nav li", function() {
      var select_raw = $(this)[0].className.split(" ")[0];
      var select_files = ".text_" + select_raw;
      $(".raw_nav li").removeClass("active");
      $(this).addClass("active");
      $(".raw_list li").removeClass("active");
      $(select_files).addClass("active");
    });

    //メニュー関連
    $(document).on("click", ".menu_btn", function() {
      $menu_btn.toggleClass('active');
      $menu.toggleClass('open');
    });

    //newsのもっと見るボタン
    // $(document).on("click", ".news .more_btn .btn", function() {
    //   $(".more_news").slideToggle();
    //   $more_btn.css('opacity', 0);
    //   TweenMax.to($more_btn, 1, {
    //     opacity: 0,
    //     onComplete: function(){
    //       $more_btn.css("display",'none');
    //     }
    //   });
    // });


  });

  function scrollShow(time) {
    $('.scroll-show').each(function(i, elm) {

      const $wh = $(window).height();
      const $st = $(window).scrollTop();
      const $sb = $st + $wh * time;

      if ($(elm).is('.is-show')) {
        return true;
      }

      const $pos = $(elm).offset().top;
      if ($pos < $sb) {
        $(elm).addClass('is-show');
      }
      return;
    });
  }

  function menu(url){
    $first_menu.removeClass("active");
    var url_pas = url[url.length - 2];
    if(url.indexOf('tag') != -1 || url.indexOf('news') != -1){
      url_pas = "news"
    }
    var set_menu = '.first_menu.menu_' + url_pas;
    if ($(set_menu).length) {
      $(set_menu).addClass("active");
    } else {
      $('.first_menu.menu_top').addClass("active");
    }
  }

  $(window).scroll(function() {
    scr = $(window).scrollTop();

    if(scr > prev_scr) {
      $fix_btn.addClass('hidden');
    } else {
      $fix_btn.removeClass('hidden');
    }
    if(scr < 200) {
      $fix_btn.addClass('hidden');
    }

    prev_scr = scr;

    if ($('body').hasClass('load')) {
      scrollShow(time);
    }

  });

  $(window).resize(function() {
    ww = window.innerWidth;
    if(ww > 750){
			$main_visual.height(window.innerHeight);
		}
  });

});
